import styled from 'styled-components';

import { Text } from '@dreryk/react-components';

export const StyledText = styled(Text)`
   margin-left: 52px;
   color: ${(props) => props.theme.heading};
`;

StyledText.displayName = 'StyledText';
